import { useQuery } from '@tanstack/react-query';

import type { TokenResult } from '@/utils/0x/token-registry.types';
import { ChainAddress } from '@/utils/models';

import { tokenEntityQueryOptions } from './tokenEntityCache';

interface UseTokenResultReturn {
  token: TokenResult | undefined;
  isLoading: boolean;
}

/**
 * Get token result for a token by contract address and chain ID. Reads from the
 * shared per-token entity cache, so a token resolved by any other hook (single,
 * batch, or SSR) is reused without a refetch.
 * @param tokenAddress - the tokenAddress to fetch the result for
 * @param chainId - the id of the chain to fetch the result for
 */
export function useTokenResult(
  tokenAddress: ChainAddress | undefined,
  chainId: number | undefined,
): UseTokenResultReturn {
  const { data, isLoading } = useQuery(tokenEntityQueryOptions(tokenAddress, chainId));

  return { token: data ?? undefined, isLoading };
}
